
import React, { PureComponent } from 'react';
import { Card, Col, Collapse, Icon, Row } from 'antd';
import { Container } from '../../../../components';
import { AppWrappperHOC } from '../../../Root/HOC';
import { StyledAuditCommittee } from '../StyledIPO';
import { DISCLOSURE_EVENTS_INFORMATION } from './constants';

const { Panel } = Collapse;

class DisclosureEventsInformation extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { DISCLOSURE_EVENTS_INFORMATION_PANEL } = DISCLOSURE_EVENTS_INFORMATION;
    return (
      <StyledAuditCommittee>
        <Container>
          <Card className="rounded card-padding-20">
            <h2 className="text-red">Disclosure of Events or Information</h2>
            <Collapse
              expandIconPosition="right"
              bordered={false}
              className="collapse-grill"
            >
              {DISCLOSURE_EVENTS_INFORMATION_PANEL.map(({ id, panelTitle, subPanel }) => (
                <Panel
                  header={<strong className="font-16">{panelTitle}</strong>}
                  key={id}
                >
                  {subPanel.map(({ subId, subPanelTitle, subPanelLink }) => (
                    <a key={subId} href={subPanelLink} target="_blank" >
                      <Row align="middle" type="flex" justify="start" gutter={[15, 25]}>
                        <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                          <h4 className="nomargin-bottom">{subPanelTitle}</h4>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6} className="text-right text-red">
                          <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                        </Col>
                      </Row>
                    </a>
                  ))}
                </Panel>
              ))}
            </Collapse>
          </Card>
        </Container>
      </StyledAuditCommittee>
    );
  }
}

const component = AppWrappperHOC(DisclosureEventsInformation);

export { DisclosureEventsInformation };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/DisclosureEventsInformation/index.jsx